import React, { useMemo } from 'react';
import { IconEmptyInbox } from '@shared/icon/icon-empty-inbox/icon-empty-inbox';
import { NetworkBase } from '../network-base/network-base';
import { NetworkEmptyProps } from './types';
import { Directory } from '@vtbhome/juicyfront/indexIcon';

export const NetworkEmpty: React.FC<NetworkEmptyProps> = ({ title = 'Данные отсутствуют', size, ...props }) => {
    const Icon = useMemo(() => {
        switch (size) {
            case 'l': {
                return IconEmptyInbox;
            }
            case 's': {
                return Directory;
            }
        }
    }, [size]);
    return <NetworkBase Icon={<Icon />} size={size} title={title} {...props} />;
};
